module.exports = __webpack_public_path__ + "static/media/013_suwaru.fc2848e8.gif";